// src/api/endpoints.js
export const endpoints = {
  // Public endpoints
  public: {
    services: '/public/packages',
    testimonials: '/public/testimonials',
    stats: '/public/stats',
    socialLinks: '/social',
    contact: '/public/contact',
    apk: '/public/apk'
  },
  // Contact endpoints (add this new section)
  contact: {
    submit: '/public/contact' // Public contact submission
  },
  // Feedback endpoints
  feedback: {
    submit: '/feedback/submit',
    list: '/feedback/my-feedback',
    get: '/feedback/:id',
    reply: '/feedback/:id/reply'
  },
  
  // Auth endpoints
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    logout: '/auth/logout',
    refresh: '/auth/refresh'
  }
}